export * from './approval.js'
export * from './permissions.js'
export * from './thread-approval.js'
export const name = '@tnega/approval-host'
